const perfix = "kjl_";
export function storage(options = {}) {
  const { key, value, type = "session" } = options;
  if (!key || typeof key != "string") return;
  const realKey = perfix + key;
  const storage = type == "session" ? sessionStorage : localStorage;
  const valueString = JSON.stringify(value);
  const result = JSON.parse(storage.getItem(realKey));
  if (value === void 0) return result;
  storage.setItem(realKey, valueString);
}
export function removeStorage(options) {
  const { key, type = "session" } = options;
  const storage = type == "session" ? sessionStorage : localStorage;
  if (!key || typeof key != "string") return;
  const realKey = perfix + key;
  storage.removeItem(realKey);
}

export function hadStorage(options = {}) {
  const { key, type = "session" } = options;
  if (!key || typeof key != "string") return false;
  const realKey = perfix + key;
  const storage = type == "session" ? sessionStorage : localStorage;
  const result =  Object.prototype.hasOwnProperty.call(storage, realKey)
  return result
}